/**
 * Shared predicate for whether a contact-picker entry has a saved Contact
 * record behind it, versus an address-derived, synthetic, or manually
 * entered row whose id is not a real Contact pk.
 *
 * Contains:
 * - isUnsavedContact — true when the entry has no saved Contact row
 */

/**
 * @param {{ id?: number, _isAddress?: boolean, _isSynthetic?: boolean, _isManualEntry?: boolean }} contact
 * @returns {boolean} True when `contact` has no saved Contact record to act on.
 */
export function isUnsavedContact(contact) {
  return Boolean(contact?._isAddress || contact?._isSynthetic || contact?._isManualEntry);
}
